import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';
import reverse from 'lodash/reverse';
import moment from 'moment';
import { SET_LATEST_NEWS, SET_PRODUCTIONS, SET_NEWS, ADD_NEWS, SET_PAGE } from '../actions/SiteActions';

const initialState = {
    pages: [],
    page: null,
    headerMenuItems: [],
    footerMenuItems: [],
    latestNews: null,
    productions: null,
    news: null,
    position: null,
    googleApiKey: null,
    productionsCategories: [],
};

const sortNews = items => reverse(sortBy(items, it => moment(it.created_at, 'YYYY-MM-DD HH:mm:ss').valueOf()));

const SiteReducer = (previousState, action) => {
    const state = {
        ...initialState,
        ...(previousState || null),
    };

    switch (action.type) {
    case SET_LATEST_NEWS:
        return {
            ...state,
            latestNews: action.payload,
        };
    case SET_PRODUCTIONS:
        return {
            ...state,
            productions: action.payload,
        };
    case SET_NEWS:
        return {
            ...state,
            news: [
                ...sortNews(action.payload),
            ],
        };
    case ADD_NEWS: {
        const news = [
            ...(state.news || []),
            ...action.payload,
        ];
        return {
            ...state,
            news: sortNews(uniqBy(news, it => it.id)),
        };
    }

    case SET_PAGE:
        return {
            ...state,
            page: action.payload,
        };
    default:
        return state;
    }
};

export default SiteReducer;



// WEBPACK FOOTER //
// ./js/reducers/SiteReducer.js